/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { WebhookCreatedResponse } from '../../models/webhook-created-response';

export interface RotateAdministrationOrganizationWebhook$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;

/**
 * The webhook key
 */
  webhookKey: KeyType;
}

export function rotateAdministrationOrganizationWebhook(http: HttpClient, rootUrl: string, params: RotateAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, rotateAdministrationOrganizationWebhook.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('webhookKey', params.webhookKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebhookCreatedResponse>;
    })
  );
}

rotateAdministrationOrganizationWebhook.PATH = '/administration/organizations/{organizationKey}/webhooks/{webhookKey}/rotate';
